import { Grid } from "@pankod/refine-mui";
import SelettoreStruttura from "components/SelettoreStruttura";
import StatisticsDateFilter from "components/StatisticsDateFilter";
import moment from "moment";
import React, { useEffect, useState } from "react";
import axios from "utils/axios";

function HeaderStatistiche({ setData, setLoading }) {
  const [start, setStart] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [end, setEnd] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [idStruttura, setIdStruttura] = useState(0);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (
        idStruttura &&
        moment(end) <= moment(new Date()) &&
        moment(start) <= moment(end)
      ) {
        //fetch data
        const res = await axios.get(
          `/api/revenue-report?start=${start}&end=${end}&facilityID=${idStruttura}`
        );

        setData(res?.data);
        console.log(res?.data);
        setLoading(false);
      }
    }
    fetchData();
  }, [start, end, idStruttura]);

  return (
    <Grid container gap={4}>
      <SelettoreStruttura
        idStruttura={idStruttura}
        setIdStruttura={setIdStruttura}
      />
      <StatisticsDateFilter
        start={start}
        setStart={setStart}
        end={end}
        setEnd={setEnd}
      />
    </Grid>
  );
}

export default HeaderStatistiche;
